<template>
  <!-- 淡紫色色模板 -->

  <div class="content">
    <div class="prefecture-wrapper">
      <img
        class="prefecture-bg"
        :src="
          competitionStyle.backgroundImgType === 1
            ? competitionStyle.backgroundImgUrl
            : bg
        "
        alt=""
      />
      <div class="prefecture">
        <h3 class="sub-title">
          <span></span>
          <span></span>
          <span>{{ competition.preparationZoneTitle || "备赛专区" }}</span>
        </h3>
        <div>
          <div class="prefecture-top">
            <div class="entrance">
              <div class="entrance-title">
                {{ competition.fastEnterTitle || "快速入口" }}
              </div>
              <div class="entrance-list">
                <div
                  :class="['entrance-item']"
                  v-for="(item, index) in competitionFastEnters"
                  :key="index"
                >
                  <div
                    class="entrance-item-child"
                    v-for="entry in item"
                    :key="entry.id"
                    @click="$emit('on-entrance', entry)"
                  >
                    <img
                      class="entrance-item-child__icon"
                      :src="requireImageURL(entry.iconType, 'rukou')"
                      alt=""
                    />
                    <span
                      class="entrance-item-child__title ql-editor"
                      v-html="entry.title"
                    >
                    </span>
                    <img
                      class="entrance-item-child__arrow"
                      src="../../../assets/template3/right-icon.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div
                class="entrance-btns"
                v-if="competitionFastEnters.length > 1"
              >
                <img
                  class="entrance-btn-left"
                  @click="scrollLeft('.entrance-list')"
                  src="../../../assets/left-icon.png"
                  alt=""
                />
                <img
                  @click="scrollRight('.entrance-list')"
                  src="../../../assets/template3/right-icon.png"
                  alt=""
                />
              </div>
            </div>

            <div class="announcement">
              <div class="announcement-title">
                {{ competition.newsTitle || "赛事公告" }}
              </div>
              <div class="announcement-list">
                <div
                  class="announcement-item"
                  v-for="(item, index) in competitionNewsList"
                  :key="index"
                >
                  <div
                    class="announcement-item-child"
                    @click="changeAnnouncement(item1)"
                    v-for="item1 in item"
                    :key="item1.id"
                  >
                    <p
                      class="name"
                      :style="{
                        color:
                          item1.isImportant == 1
                            ? competitionStyle.importantNewsColor
                            : '#666',
                      }"
                    >
                      {{ item1.title }}
                    </p>
                    <p class="time">{{ item1.publishDate }}</p>
                  </div>
                </div>
              </div>
              <div class="announcement-btn" v-if="iCompetitionNews">
                <img
                  class="announcement-btn-left"
                  @click="scrollLeft('.announcement-list')"
                  src="../../../assets/left-icon.png"
                  alt=""
                />
                <img
                  @click="scrollRight('.announcement-list')"
                  src="../../../assets/template3/right-icon.png"
                  alt=""
                />
              </div>
            </div>

            <div class="introduce">
              <h3 class="introduce-title">
                {{ competition.introTitle || "大赛介绍" }}
              </h3>
              <div
                class="introduce-content"
                v-html="competitionIntro.content"
              ></div>
            </div>

            <div class="resource">
              <h3 class="resource-title">
                {{ competition.resourceTitle || "资源下载" }}
              </h3>
              <div class="resource-list">
                <div
                  class="resource-list-item"
                  v-for="(competitionResource, index) in competitionResources"
                  :key="index"
                >
                  <div
                    class="resource-item"
                    v-for="item in competitionResource"
                    :key="item.id"
                  >
                    <img class="resource-item__img" :src="item.imgUrl" alt="" />
                    <div class="resource-item-right">
                      <h4 class="resource-item-title">{{ item.title }}</h4>
                      <p class="resource-item-desc">{{ item.subtitle }}</p>
                      <a
                        href="javascript:;"
                        class="resource-item-download"
                        @click="download(item.fileUrl)"
                        >下载</a
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="entrance-btns"
                style="margin-top: 32px"
                v-if="competitionFastEnters.length > 1"
              >
                <img
                  class="entrance-btn-left"
                  @click="scrollLeft('.resource-list')"
                  src="../../../assets/left-icon.png"
                  alt=""
                />
                <img
                  @click="scrollRight('.resource-list')"
                  src="../../../assets/template3/right-icon.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="arrange">
      <h3 class="sub-title">
        <span></span>
        <span></span>
        <span>{{ competition.planTitle || "赛事安排" }}</span>
      </h3>
      <div class="arrange-list">
        <div
          class="arrange-list__prev-btn"
          @click="scrollLeft('.msg')"
          v-if="competitionPlanList.length > 5"
        >
          <img
            src="../../../assets/template3/saishianpai-left-icon.png"
            alt=""
          />
        </div>
        <div class="msg">
          <div class="item" v-for="item in competitionPlanList" :key="item.id">
            <img
              class="msg__img"
              :src="requireImageURL(item.iconType, 'saishianpai')"
              alt=""
            />
            <h4>{{ item.title }}</h4>
            <div class="line">
              <div class="left-line"></div>
              <div class="dot"></div>
              <div class="right-line"></div>
            </div>
            <div class="ql-editor">
              <div v-html="item.planTime"></div>
            </div>
          </div>
        </div>
        <div
          class="arrange-list__next-btn"
          @click="scrollRight('.msg')"
          v-if="competitionPlanList.length > 5"
        >
          <img
            src="../../../assets/template3/saishianpai-right-icon.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bg from "../../../assets/template3/bg.png";

export default {
  name: "PalePurpleTemplate",
  props: {
    competitionFastEnters: {
      type: Array,
      default: () => [],
    },
    competitionNewsList: {
      type: Array,
      default: () => [],
    },
    competitionResources: {
      type: Array,
      default: () => [],
    },

    competitionPlanList: {
      type: Array,
      default: () => [],
    },
    isCompetitionFastEnter: { type: Boolean, default: false }, //快速入口分页按钮
    iCompetitionNews: { type: Boolean, default: false }, //赛事公告分页按钮
    isCompetitionResource: { type: Boolean, default: false }, //资源下载分页按钮
    fullscreenLoading: { type: Boolean, default: false }, //全局加载状态
    competitionIntro: {
      type: Object,
      default: () => ({}),
    },
    competitionStyle: {
      type: Object,
      default: () => ({}),
    },
    competition: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return { bg };
  },
  mounted() {},
  methods: {
    download(fileUrl) {
      window.location.href = fileUrl;
    },

    //{{ competition.newsTitle || "赛事公告" }}
    changeAnnouncement(item) {
      window.open(item.url);
    },
    //动态图标
    requireImageURL(iconType, name) {
      // 根据图标类型拼接图片路径
      return require(`@/assets/template3/${name}-icon-${iconType}.png`);
    },

    scrollLeft(name) {
      const dataBar = document.querySelector(name);
      dataBar.scrollTo({
        left: dataBar.scrollLeft - dataBar.clientWidth,
        behavior: "smooth",
      });
    },

    scrollRight(name) {
      const dataBar = document.querySelector(name);
      dataBar.scrollTo({
        left: dataBar.scrollLeft + dataBar.clientWidth,
        behavior: "smooth",
      });
    },

    // calcBottomBorder(index) {

    // },
  },
};
</script>

<style lang="scss" scoped>
.announcement-list {
  display: flex;
  overflow-x: auto;
  margin-top: 20px;
}
.announcement-list::-webkit-scrollbar {
  display: none !important;
}
.announcement-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 9px;
}
.announcement-btn img {
  width: 10px;
  height: 18px;
  cursor: pointer;
}
.announcement-btn-left {
  margin-right: 80px;
}

.announcement .announcement-title {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}
.announcement-item-child {
  display: flex;
  align-items: center;
  justify-content: space-between;

  cursor: pointer;
  color: #666;
  border-bottom: 1px solid #e5e5e5;

  &:not(:last-child) {
    padding-bottom: 12px;
    margin-bottom: 12px;
  }
}
.announcement-item-child:last-child {
  border-bottom: none;
}
.announcement-item-child .name {
  font-size: 14px;
  width: 360px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.announcement-item-child .time {
  font-size: 14px;
  font-weight: 400;
}
.announcement-item {
  width: 100%;
  flex-shrink: 0;
}
.emphasis {
  font-weight: 600;
  color: #7a68fe;
}
.unemphasis {
  font-weight: 400;
}
.btns {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}
.btns img {
  width: 10px;
  height: 18px;
  cursor: pointer;
}
.btns img:first-child {
  margin-right: 80px;
}

.prefecture-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.prefecture-top {
  .announcement,
  .resource,
  .introduce {
    box-sizing: border-box;
    width: 575px;
    padding: 20px 30px;
    border-radius: 20px;
    border: 1px solid #7a68fe;
    background: #fff;
    margin-top: 30px;
  }
  .announcement {
    height: 316px;
  }
}

.introduce {
  height: 256px;
  &-content {
    height: 160px;
    overflow-y: auto;
    white-space: pre-wrap;
  }

  &-title {
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &-content::-webkit-scrollbar {
    display: none !important;
  }
}

.line {
  display: flex;
  align-items: center;
  margin-top: 25px;
}
.left-line {
  width: 89px;
  height: 4px;
  background: #7a68fe;
}
.right-line {
  width: 89px;
  height: 4px;
  background: #7a68fe;
}
.dot {
  position: relative;
  top: -4px;
  width: 18px;
  height: 24px;
  background: url("../../../assets/template3/dot.png");
  background-size: cover;
}
.detail {
  display: flex;
  padding: 0 50px;
  margin-top: 62px;
}
.detail .img {
  padding-top: 42px;
}
.detail img {
  width: 52px;
  height: 52px;
  cursor: pointer;
}
.detail .msg {
  flex: 1;
  /* width: 100px; */
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  overflow-x: auto;
}

.container {
  background: #171f30;
}
.content {
  position: relative;
  color: #333;
  background: #fff;
}
.arrange {
  width: 1180px;
  margin: 0 auto;
  padding: 50px 0;

  &-list {
    margin-top: 50px;
    display: flex;
    justify-content: center;

    &__prev-btn {
      width: 52px;
      height: 52px;
      margin-right: 42px;
      margin-top: 20px;

      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }

    &__next-btn {
      width: 52px;
      height: 52px;
      margin-left: 42px;
      margin-top: 20px;

      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }

    .msg {
      display: flex;
      align-items: flex-start;
      overflow-x: auto;

      &::-webkit-scrollbar {
        display: none !important;
      }

      .item {
        width: 196px;
        display: flex;
        flex-direction: column;
        align-items: center;

        cursor: pointer;

        h4 {
          margin-top: 20px;
          font-size: 18px;
          font-weight: 400;
        }
      }

      &__img {
        width: 90px;
        height: 90px;
      }
    }
  }
}
.sub-title {
  position: relative;
  font-size: 32px;

  height: 32px;
  line-height: 32px;

  span:nth-child(1) {
    display: inline-block;
    width: 10px;
    height: 32px;
    margin-left: 5px;
    margin-right: 20px;
    background: #7a68fe;
    vertical-align: -5px;
    border-radius: 6px;
  }
}

.prefecture {
  position: relative;
  width: 1180px;
  padding: 50px 0;
  margin: 0 auto;

  &-wrapper {
    position: relative;
  }

  &-bg {
    position: absolute;
    left: 0;
    width: 100%;
    height: 770px;
    object-fit: cover;
    z-index: 0;
  }
}

.entrance {
  box-sizing: border-box;
  width: 575px;
  height: 316px;
  padding: 20px 30px;
  border-radius: 20px;
  border: 1px solid #7a68fe;
  background: #fff;
  margin-top: 30px;

  &-title {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
  }

  &-list {
    display: flex;
    overflow-x: auto;
    margin-top: 20px;

    &::-webkit-scrollbar {
      display: none !important;
    }
  }

  &-item {
    display: flex;
    flex-shrink: 0;
    flex-wrap: wrap;
    width: 100%;

    &-child {
      box-sizing: border-box;
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 56px;

      &:nth-child(odd) {
        border-right: 1px solid #e5e5e5;
        padding-right: 30px;
      }

      &:nth-child(even) {
        padding-left: 30px;
      }

      &__title {
        flex: auto;
        margin: 0 20px 0 18px;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;

         // 下列属性是覆盖 ql-editor
        height: auto;
        padding: 0;
      }

      &__icon {
        width: 18px;
        height: 18px;
        cursor: pointer;
      }

      &__arrow {
        width: 7px;
        height: 13px;
        cursor: pointer;
      }
    }
  }

  &-btns {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;

    img {
      width: 10px;
      height: 18px;
      cursor: pointer;
    }
    .entrance-btn-left {
      margin-right: 80px;
    }
  }
}

// .entrance-list::-webkit-scrollbar {
//   display: none !important;
// }

.resource {
  height: 256px;

  &-list {
    display: flex;
    margin-top: 20px;
    overflow-x: auto;

    &::-webkit-scrollbar {
      display: none !important;
    }

    &-item {
      display: flex;
      flex-shrink: 0;
      width: 100%;
    }
  }

  &-title {
    text-align: center;
    font-size: 20px;
    font-weight: 700;
  }

  &-item {
    display: flex;
    justify-content: space-between;
    width: 252px;

    &:nth-child(odd) {
      margin-right: 20px;
    }

    &__img {
      width: 100px;
      height: 100px;
    }

    &-right {
      position: relative;
      width: 132px;
    }

    &-title {
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &-desc {
      margin-top: 10px;
      font-weight: 400;
      font-size: 16px;
      color: #909399;
    }

    &-download {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 56px;
      height: 25px;
      line-height: 25px;
      background: #7a68fe;
      border-radius: 13px;
      text-align: center;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>
